import { ToastPlugin } from 'bootstrap-vue';
export default {
    install: function (Vue, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.autoHideDelay, autoHideDelay = _c === void 0 ? 5000 : _c, _d = _b.appendToast, appendToast = _d === void 0 ? true : _d, _e = _b.position, position = _e === void 0 ? 'bottom' : _e;
        Vue.use(ToastPlugin);
        Vue.prototype.$toast = function (message, variant) {
            if (variant === void 0) { variant = 'success'; }
            this.$bvToast.toast(message.toString(), {
                title: this.$t("toast." + variant).toString(),
                autoHideDelay: autoHideDelay,
                appendToast: appendToast,
                toaster: position === 'top' ? 'b-toaster-top-right' : 'b-toaster-bottom-right',
                variant: variant,
            });
        };
        Vue.prototype.$postToast = function (message, variant) {
            if (variant === void 0) { variant = 'success'; }
            this.$bvToast.toast(message.toString(), {
                autoHideDelay: autoHideDelay,
                noCloseButton: true,
                appendToast: false,
                toaster: position === 'top' ? 'b-toaster-top-right' : 'b-toaster-bottom-right',
                variant: variant,
                toastClass: "sr-only",
            });
        };
    }
};
